<template>
  <div>
    <flickity
      ref="flickityClasses"
      @init="onInit"
      :options="flickityOptions"
    >
      <ClassItem
        v-for="lesson in lessons"
        :class="{'active-item': lesson.id == selected}"
        :key="lesson.id"
        :data="lesson"
        class="classes-item"
        @menu-clicked="setLesson(lesson.id)"
      ></ClassItem>
    </flickity>
    <transition name="address-fade" mode="out-in">
      <div class="flickity-address" :key="animate">
        <template v-if="lesson">
          <span v-if="lesson.isOnline">
            {{ $t('dashboard.online') }}<span v-if="onlineClassesLink !== ''">: </span>
          </span>
          <span v-else class="flickity-address__stationary">
            {{ lesson.localization ? lesson.localization.address : '-' }}
            <span class="flickity-address__dot"></span>
            {{ $t('dashboard.class_room') }} {{ lesson.room ? lesson.room.name : '-' }}
            <span class="flickity-address__dot"></span>
            {{ lesson.localization ? lesson.localization.name : '-' }}
          </span>
          <a v-if="lesson.isOnline && onlineClassesLink !== ''" class="font-bold text-blue-zoom no-underline zoom-link-classes" :href="onlineClassesLink" target="_blank" rel="nofollow">
            <span>{{ $t('dashboard.join_meeting') }}</span>
          </a>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ClassItem from './ClassItem.vue';

export default {
  name: 'ClassList',

  components: {
    ClassItem,
  },

  props: {
    lessons: Array,
  },

  data() {
    return {
      selected: '',
      animate: false,
      flickityOptions: {
        cellAlign: 'left',
        percentPosition: false,
        pageDots: false,
      },
    };
  },

  computed: {
    ...mapState('lessons', ['lesson']),
    ...mapState('students', ['student']),

    onlineClassesLink() {
      return this.student.group.zoomUrl;
    },
  },

  methods: {
    setLesson(id) {
      this.selected = id;
      this.animate = !this.animate;
    },
    onInit() {
      this.$refs.flickityClasses.on('change', () => {
      });
    },
  },

  mounted() {
    this.selected = Math.min(...this.lessons.map(lesson => lesson.id));
  },
};
</script>

<style lang="scss">
.flickity-container {
  @apply mt-1 relative;
  @media screen and (min-width: 992px) {
    @apply px-12;
  }
  &.--static {
    @apply px-0;
  }
  .flickity-address {
    @apply text-sm mt-4;
    height: 28px;
    &__stationary {
      @apply flex items-center flex-wrap;
      height: 100%;
    }
    &__dot {
      @apply bg-pink-main;
      display: inline-block;
      width: 6px;
      height: 6px;
      margin-right: 5px;
      margin-left: 5px;
      border-radius: 50px;
    }
  }
}

.address-fade-enter-active {
  transition: all 0.3s ease;
}

.address-fade-leave-active {
  transition: all 0.4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.address-fade-enter,
.address-fade-leave-to {
  transform: translateY(25px);
  opacity: 0;
}

.controls {
  .flickity-button {
    background: transparent;
  }

  .flickity-prev-next-button {
    width: 40px;
    height: 40px;
    transform: rotate(0deg);
    border: 0 !important;
    border-radius: 0;

    &:after {
      display: none !important;
    }
  }

  .flickity-prev-next-button.previous,
  .flickity-prev-next-button.next {
    top: 12px;
    display: block;
    margin: 0 auto;
    border-top: 3px solid #1b181a;
    border-left: 3px solid #1b181a;
    opacity: 0;
    background-image: url("~@/assets/images/icons/arrow-right-pink.svg");
    background-repeat: no-repeat;
    background-position: center;
    @media screen and (min-width: 768px) {
      opacity: 1;
    }
    svg {
      display: none;
    }
  }

  .flickity-prev-next-button.previous {
    left: -55px;
    transform: rotate(-180deg);
    transition: 0.5s left, 0.5s opacity;
    &:hover {
      left: -65px;
    }
  }

  .flickity-prev-next-button.next {
    right: -55px;
    transition: 0.5s right, 0.5s opacity;
    &:hover {
      right: -65px;
    }
  }

  .flickity-button:disabled {
    opacity: 0;
  }
}
</style>
